import type { MouseEventHandler, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { CrownIcon } from '../icons/CrownIcon';
import { classes } from '../layout/space';
import './PremiumBadge.css';
import './PremiumTierIdentity.css';
import type { PremiumTier } from './tierIdentity';

export function PremiumBadge({ children, className, to, onClick, tier }: { children: ReactNode; tier?: PremiumTier; className?: string; to?: string; onClick?: MouseEventHandler<HTMLAnchorElement> }) {
  if (to) return <Link data-premium-tier={tier} to={to} className={classes('premium-badge', className)} onClick={onClick}><CrownIcon /><span>{children}</span></Link>;
  return (
    <span data-premium-tier={tier} className={classes('premium-badge', className)}>
      <CrownIcon />
      <span>{children}</span>
    </span>
  );
}
